import React from "react";

// The official Amden logo is dark; on dark surfaces we place it on a light chip.
export function Logo({ variant = "light", showCompass = true, className = "" }) {
  const onDark = variant === "dark";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="amden-logo">
      <div
        className={`flex items-center justify-center rounded-lg px-2.5 py-1.5 ${
          onDark ? "bg-white" : "bg-transparent"
        }`}
      >
        <img src="/amden-logo.png" alt="Amden Group" className="h-6 w-auto object-contain" />
      </div>
      {showCompass && (
        <div className="flex items-center gap-2">
          <span className={`h-4 w-px ${onDark ? "bg-white/25" : "bg-[#0B1729]/15"}`} />
          <span
            className={`font-display text-lg font-semibold tracking-tight ${
              onDark ? "text-white" : "text-[#0B1729]"
            }`}
          >
            Compass
          </span>
        </div>
      )}
    </div>
  );
}

export function LogoMark({ className = "h-8 w-auto" }) {
  return <img src="/amden-logo.png" alt="Amden Group" className={className} />;
}
